/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CPSheetUserAnalyticsDash from "../../../../components/CPSheet/Analytics/User";
import Navbar from "../../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../../constants/routes";

const CPSheetUserAnalytics = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.cpSheetAnalytics?.hasUserDashboardAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <CPSheetUserAnalyticsDash adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default CPSheetUserAnalytics;
